import { useHistory } from 'react-router-dom'
import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    const history = useHistory()
    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/abdomenContraste/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/abdomenContraste/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/abdomenContraste/linhasReferencia"
        },
        
        {
            text: "Reformatações Multiplanares",
            url: "/abdomenContraste/reformatacoesMultiplanares"
        },
        {
            text: "Protocolos de Pós-processamento",
            url: "/abdomenContraste/reformatacoes"
        },
        {
            text: "Back-Up",
            url: "/abdomenContraste/reformatacoes/BackUp"
        },
        {
            text: "Documentação",
            url: "/abdomenContraste/reformatacoes/Documentacao"
        },
    ]
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice Abdômen Superior com Contraste I.V.</Title>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}